angular.module('app.common').component('loadingIcon', {
  templateUrl: 'common/common/components/loading-icon.html',
  bindings: {},
});
